import "./createScreen.css";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const CreateScreen = () => {
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [saveTemplets, setSaveTemplets] = useState([]);
  const navigate = useNavigate();

  const handleChange = (event) => {
    setSelectedTemplate(event.target.value);
  };

  const handleContinue = async () => {
    try {
      const response = await fetch(
        "https://dev-api.wipovtool.com/api/v1/admin/file-upload/list"
      );
      if (response.ok) {
        const jsonResponse = await response.json();
        const templateData = jsonResponse.data
          .filter((template) => template.url.endsWith(".scene")) // Filter only .scene files
          .map((template) => ({
            id: template.name,
            url: template.url,
            label: { en: template.name }, // Assuming the name is used as a label
            image_name: template.url, // Assuming the URL is used as the image source
            data: template, // Add the entire scene data here
          }));

        setSaveTemplets(templateData);

        const selectedTemplateData = templateData.find(
          (template) => template.id === selectedTemplate
        );
        if (selectedTemplateData) {
          navigate("/video-template", {
            state: { selectedTemplate: selectedTemplateData },
          });
        } else {
          console.error(`Template with ID ${selectedTemplate} not found`);
        }
      } else {
        console.error("Failed to fetch templates from API");
      }
    } catch (error) {
      console.error("Failed to fetch templates from API:", error);
    }
  };

  const handleHomeClick = () => {
    navigate("/");
  };

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        const response = await fetch(
          "https://dev-api.wipovtool.com/api/v1/admin/file-upload/list"
        );

        if (response.ok) {
          const jsonResponse = await response.json();
          const templateData = jsonResponse.data
            .filter((template) => template.url.endsWith(".scene")) // Filter only .scene files
            .map((template) => ({
              id: template.name,
              url: template.url,
              label: { en: template.name }, // Assuming the name is used as a label
              image_name: template.url, // Assuming the URL is used as the image source
              data: template, // Add the entire scene data here
            }));
          setSaveTemplets(templateData);
        } else {
          console.error("Failed to fetch templates from API");
        }
      } catch (error) {
        console.error("Failed to fetch templates from API:", error);
      }
    };

    fetchTemplates();
  }, []);

  return (
    <div className="main_block">
      <div className="container">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h2 className="main_heading">Create Smart News</h2>
          <div>
            <button
              className="btn btn-secondary btn-home"
              onClick={handleHomeClick}
            >
              Home
            </button>
          </div>
        </div>

        <div className="select_template btn-home">
          <div className="template_drag">
            <h3>Select the starting template</h3>
            <FormControl sx={{ m: 1, minWidth: 120 }}>
              <Select
                value={selectedTemplate}
                onChange={handleChange}
                displayEmpty
                inputProps={{ "aria-label": "Select Template" }}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {saveTemplets.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {/* <img
                      src={item.image_name}
                      alt={item.label.en}
                      width="50px"
                      height="50px"
                    /> */}
                    {item.label.en}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className="action_btn">
            <a href="#" className="btn btn-secondary">
              Cancel
            </a>
            <button onClick={handleContinue} className="btn">
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateScreen;
